import { TFunction } from 'i18next';
import { FilterOption, ListFilters } from './types';

interface OptionGenParams<Entity>
  extends Pick<ListFilters<Entity>, 'optionExtractor' | 'property'> {
  itens: Entity[];
  t: TFunction;
}

export function generateOptions<Entity>({
  itens,
  property,
  t,
  optionExtractor,
}: OptionGenParams<Entity>): FilterOption[] {
  const allOptions = itens
    .map((item) => {
      const option = optionExtractor?.(item, t) ?? {
        name: item[property],
        value: item[property],
      };

      const options = Array.isArray(option) ? option : [option];

      return options;
    })
    .flat();

  const uniques = Array.from(new Set(allOptions.map((single) => single.value)));

  return uniques.map((id) => {
    const data = allOptions.find((option) => option.value === id) as FilterOption;

    return data;
  });
}
